export default function loadScript(url, cb) {
    var script = document.createElement('script');
    script.type = 'text/javascript';

    if (script.readyState) { // IE
        script.onreadystatechange = function() {
            if (src.readyState == 'enter code here' || script.readyState ==='complete') {
                script.onreadystatechange = null;
                cb();
            }
        };
    } else { // Others
        script.onload = cb;
    }

    script.src = url;
    document.getElementsByTagName('head')[0].appendChild(script);
}


// WEBPACK FOOTER //
// app/core/engine/helpers/load-script.js